import React, { useEffect, useState } from 'react';
import './Newsletter.scss';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { useMediaQuery } from 'react-responsive';
import { isExternalLink, safeHtml } from '../../../../services/helpers';
import { baseStrapiURL } from '../../../../services/config';

const Newsletter = ({ strapiData, direction = 'text to picture', withFreePatch }) => {

    const isSmallMobile = useMediaQuery({ maxWidth: 335 });

    const [backgroundImage, setBackgroundImage] = useState(baseStrapiURL + strapiData.Photo.url);
    
    useEffect(() => {
        const checkWebPSupport = () => {
            const img = new Image();
            img.onload = () => {
                if (img.height > 0 && img.width > 0) {
                    setBackgroundImage(baseStrapiURL + strapiData.Photo.url);
                }
            };

        };
        checkWebPSupport();
    }, []);

    return (
        <section className="newsletter-ad">
            <div
                className={direction === 'picture to text' ? 'newsletter-ad__content newsletter-ad__content_reverse' : 'newsletter-ad__content newsletter-ad__content_no_reverse'}
            >
                <div
                    className="newsletter-ad__text"
                >
                    {
                        isSmallMobile ?
                            <div dangerouslySetInnerHTML={safeHtml(strapiData.ContenuMobile)} />
                            :
                            <div dangerouslySetInnerHTML={safeHtml(strapiData.Contenu)} />
                    }
                    <CustomBtn
                        type={isExternalLink(strapiData.Bouton.LienBouton) ? 'external' : 'internal'}
                        title={strapiData.Bouton.TexteBouton}
                        link={
                            strapiData.Bouton.LienBouton === null ?
                                ''
                            :
                                (isExternalLink(strapiData.Bouton.LienBouton) ?
                                    strapiData.Bouton.LienBouton
                                :
                                    '/' + strapiData.Bouton.LienBouton)
                        }
                        bkg_color={'transparent'}
                        bkg_color_hover={'#EEE6DB'}
                        text_color={'#361215'}
                        text_color_hover={'#361215'}
                        border_color={'#361215'}
                        border_color_hover={'#361215'}
                        font_family={'Great Vibes'}
                        font_size={'35px'}
                        border_radius={'3px'}
                        width={'212px'}
                        height={'59px'}
                        margin={'20px 0'}
                    />
                </div>
                {
                    withFreePatch &&
                    <div
                        className={direction === 'picture to text' ? 'newsletter-ad__free_patch newsletter-ad__free_patch_content_reverse' : 'newsletter-ad__free_patch newsletter-ad__free_patch_content_no_reverse'}
                    >
                        GRATUIT
                    </div>
                }
                <div
                    className="newsletter-ad__image"
                    aria-label={strapiData.Photo.alternativeText}
                    style={{ backgroundImage: `url(${backgroundImage})` }}
                ></div>
            </div>
        </section>
    );
};

export default Newsletter;